/* eslint-disable react/jsx-no-useless-fragment */
import React, { Fragment } from 'react';
import {
  node,
  number,
  shape,
  string,
} from 'prop-types';
import 'styles/Layout.scss';

const getClassNames = (xs, sm, md, lg, className) => {
  const output = ['layout-column'];
  if (xs) {
    output.push(`column-xs-${xs}`);
  }
  if (sm) {
    output.push(`column-sm-${sm}`);
  }
  if (md) {
    output.push(`column-md-${md}`);
  }
  if (lg) {
    output.push(`column-lg-${lg}`);
  }
  if (className) {
    output.push(className);
  }
  return output;
};

const Column = ({
  style,
  xs,
  sm,
  md,
  lg,
  children,
  className,
  ...rest
}) => (
  <div style={style} className={getClassNames(xs, sm, md, lg, className).join(' ')} {...rest}>
    {children}
  </div>
);

Column.defaultProps = {
  children: <Fragment />,
  className: null,
  xs: null,
  sm: null,
  md: null,
  lg: null,
  style: {},
};

Column.propTypes = {
  style: shape({}),
  className: string,
  children: node,
  xs: number,
  sm: number,
  md: number,
  lg: number,
};

export default Column;
